import { useAppDispatch } from 'lib/centralStore';

import { BannerHeroRenderer } from 'components/banner/bannerHero';
import { Category } from 'types/categoryEnum';
import { HeaderTitleWithSearch } from 'components/headerTitleWithSearch';
import { ScommesseLayout } from 'features/scommesseLayout';
import { SportComposer } from 'features/sport/components/sportComposer';
import { SportInfoPageQuery } from 'lib/datoCms/queries/getSportInfoPage';
import { SportInternalLayout } from 'features/sport/components/sportInternalLayout';
import { SportTopNavigation } from 'features/sport/components/sportTopNavigation';
import { TabsWithAccordion } from 'components/tabsWithAccordion';
import { TabsWithAccordionType } from 'lib/datoCms/queries/getSeoData';
import { Taxes } from 'features/sport/components/sportTicket/sportTicketSlice';
import { errorLabelsUpdated } from 'features/carrello/carrelloSlice';
import { isSnaiSite } from 'utility/constant';
import { isTruthy } from 'utility/functions';
import { seoItemHierarchy } from 'components/staticMap';
import { useEffect } from 'react';
import useWindowSize from 'hooks/useWindowSize';

type Props = SportInfoPageQuery & {
  taxes?: Taxes;
  seoData?: TabsWithAccordionType;
  staticMenu?: seoItemHierarchy;
};

const PageContent = ({ taxes, seoData, sportNav, staticMenu, sportInfoPage, allCarrelloErrors }: Props) => {
  const dispatch = useAppDispatch();

  const { id, visualComposer, heroBanner } = sportInfoPage ?? {};
  const { tabs, titoloDiRiferimento: title } = seoData ?? {};

  const { isMobile } = useWindowSize();
  const [sportTrKey] = ['sport'];

  useEffect(() => {
    dispatch(errorLabelsUpdated(allCarrelloErrors));
  }, [dispatch, allCarrelloErrors]);

  return (
    <ScommesseLayout taxes={taxes} hasNoPaddingOnMain>
      <HeaderTitleWithSearch
        title={'Sport'}
        category={Category.Sport}
        titleTrKey={sportTrKey}
        labelSearch={null}
        hasPaddingLeft={isMobile}
        titleHighlighted={title}
      />
      {isTruthy(heroBanner?.[0]?.banners?.length) && <BannerHeroRenderer pageId={id} heroBanner={heroBanner?.[0]} />}
      <SportTopNavigation hasFirstElementFixed={isSnaiSite} />
      {/* <HeaderSticky label={sportHeaderStickyLabel} /> */}
      <SportInternalLayout sportNav={sportNav} staticMenu={staticMenu}>
        {isTruthy(visualComposer?.length) && (
          <SportComposer pageId={id} cmsData={visualComposer!} templateSlug="templateDisciplina" />
        )}
        <TabsWithAccordion tabs={tabs ?? []} />
      </SportInternalLayout>
    </ScommesseLayout>
  );
};

export default PageContent;
